<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data" placeholder="请选择"
           :multiple='multiple'  @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    // import { findTypeList } from "@/services/deviceOrder";
     import {getCascade} from '@/services/product'

    export default {
        name: 'MultipleType',
        props: {
            value: {},
            // type:"",
             brandId:{
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {data: [], deviceType: []}
        },
        watch: {
            value:{
                immediate: true,
                handler(value) {
                    this.data=value;
                }
            },
            // type:{
            //     immediate:true,
            //     handler(type){
                    
            //                this.loadData(type);
                      

            //     }
            // },
             brandId:{
                immediate:true,
                handler(value){
                    this.loadData(value);
                }
            },
           
        },
        mounted() {
            // this.loadData();
        },
        methods: {
           
            handleChange(value) {
                

                this.$emit("input",value);
                this.$emit("change", value)
                this.data=value;
            },
            async loadData(brandId) {
               this.deviceType =[]
               this.data = [];
                // const response = await findTypeList( { type: type, });
              
                // if (response&&response.code==0) {
                //     this.deviceType = response.data.map((item, i) => {
                //         return {name: item.name, value: item.name}
                //     })
                // }
               const response = await getCascade( { brandId });
              
                if (response&&response.code==0) {
                    this.deviceType = response.data.brand.map((item, i) => {
                        return {name: item.brandName, value: item.brandId}
                    })
                }
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/deviceTypeMultiple.vue